
/**
 * 주문 상태
 */
export type OrderListResponseOrdersItemStatus = typeof OrderListResponseOrdersItemStatus[keyof typeof OrderListResponseOrdersItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderListResponseOrdersItemStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
} as const;
